<template>
  <router-view :class="theme" />
</template>

<script>
export default {
  name: "AppTemplate",
  data() {
    return {
      theme: this.$store.getters.theme ? this.$store.getters.theme : "light",
    };
  },
};
</script>
